import { SessionManager as BaseSessionManager } from '@egr/xbox/base-app/managers/SessionManager';

export class SessionManager extends BaseSessionManager {
    public constructor() {
        super();
    }

    public async startEaiwsSession(primaryDataLanguage?: string): Promise<void> {
        return Promise.resolve();
    }
}